import {useEffect, useState} from 'react';
import {GET_COL_AGGREGATE_DATA} from '../../../api';
import 'datatables.net';
import 'datatables.net-responsive';
import $ from "jquery";
import {Link} from "react-router-dom";
import cogoToast from "cogo-toast";
import {agent, sync} from "../../../api/app";
import DTLeaderBoard from "../../../components/layout/DTLeaderBoard";
import {capitalize} from "../../../utils/capitalize";
import generateChar from "../../../utils/generateChar";
import {agentQuery} from "../../../query/aggregation";
import moment from "moment";
import {useDispatch, useSelector} from "react-redux";

const Agent = (props) => {

    document.title = "Agent";

    const [stateReady, setStateReady] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [editId, setEditId] = useState(0);
    const [id, setId] = useState(new Date().getTime());
    const token = localStorage.getItem('jwtToken');
    const dispatch = useDispatch();

    const {province, districts, constituencies, wards, polling_stations} = useSelector(state => state.app?.administrative);

    useEffect(() => {
        dispatch(sync());
    }, []);

    useEffect(() => {
        let table = $('#agent-table').DataTable({
            responsive: true,
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Agent Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                const term = (data.search.value || '').trim();
                const searchMatch = term ? {
                    $match: {
                        $or: [
                            { name: { $regex: term, $options: 'i' } },
                            { username: { $regex: term, $options: 'i' } },
                            { mobile_number: { $regex: term, $options: 'i' } },
                            { id_number: { $regex: term, $options: 'i' } }
                        ]
                    }
                } : null;

                const baseFilter = {
                    $match: {}
                };

                $.ajax(GET_COL_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    contentType: 'application/json',
                    data: JSON.stringify({
                        query: $('.dataTables_filter input').val(),
                        collection: "agent",
                        filter: agentQuery(data.start, data.length, baseFilter, searchMatch),
                        pageSize: data.start,
                        format: 'json',
                        sort: {_id: -1},
                        pageIndex: (data.length + data.start) / data.length
                    }),
                    success: function (res) {
                        let records = res.data[0] || { results: [], totalCount: [] };
                        let total = records.totalCount.length > 0 ? records.totalCount[0].count : 0;

                        let array = records.results.map(row => ({ raw: row }));

                        callback({
                            recordsTotal: total,
                            recordsFiltered: total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a class="nav link-02" href="#/agent/${data._id}">${capitalize(data.name)} ${data.verified.status ? `<i class="mg-l-2 fa fa-check-circle tx-primary"/>` : ""}</a></nav>`;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.username;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return capitalize(data?.position || "Not Set");
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return {
                            true : `<span class="badge badge-success tx-white">Active</span>`,
                            false : `<span class="badge badge-danger tx-white">Inactive</span>`
                        }[data.active];
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link edit_agent"><i class="fa fa-pencil"></i> Edit</a> <a href="javacsript:void(0)" class="nav-link verify_agent"><i class="fa fa-check-circle"></i> Verify</a> <a href="#" class="nav-link activate_agent"><i class="fa fa-power-off"></i> ${data.active ? "Deactivate" : "Activate"}</a></nav>`
                    },
                    "targets": 5
                }
            ]
        });

        table.on('click', '.view_agent', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();
            props.history.push(`/agent/${extract_td.raw._id}`);
        });

        table.on('click', '.delete_agent', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this account?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                agent("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("Account successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.edit_agent', function (e) {
            e.preventDefault();

            const extract_td = table.row($(this).closest('tr')).data();

            setEditForm(true);
            setEditId(extract_td.raw._id);

            // Fill form fields
            $("#name").val(extract_td.raw.name);
            $("#username").val(extract_td.raw.username).prop("disabled", true);
            $("#contact-number").val(extract_td.raw.mobile_number);
            $("#position").val(extract_td.raw.position);
            $("#role").val(extract_td.raw.role);
            $("#id-number").val(extract_td.raw.id_number);
            $("#password").prop("required", false);
            $('#b1a').prop({ checked: extract_td.raw?.access?.statistic });
            $('#b2a').prop({ checked: extract_td.raw?.access?.agent });

            initialize();

            const adminLevels = extract_td.raw.admin_level || [];

            const getLevel = (model) => {
                return (adminLevels.find(l => l.model === model) || {}).data || [];
            };

            // Selected full objects per level
            const selectedProvinces = getLevel('administrative');
            const selectedDistricts = getLevel('district');
            const selectedConstituencies = getLevel('constituency');
            const selectedWards = getLevel('ward');
            const selectedPollings = getLevel('polling');

            // Extract only IDs for comparison
            const selectedProvinceIds = selectedProvinces.map(p => p._id);
            const selectedDistrictIds = selectedDistricts.map(d => d._id);
            const selectedConstituencyIds = selectedConstituencies.map(c => c._id);
            const selectedWardIds = selectedWards.map(w => w._id);

            // Set provinces
            $('#province').val(selectedProvinceIds).trigger('change');

            // Filter & set districts
            const filteredDistricts = districts.filter(d =>
                selectedProvinceIds.includes(d.administrative)
            );

            $('#district').empty().select2({
                placeholder: 'Select Districts',
                multiple: true,
                width: '100%',
                data: filteredDistricts.map(d => ({
                    id: d._id,
                    text: capitalize(d.name)
                }))
            }).val(selectedDistrictIds).trigger('change');

            // Filter & set constituencies
            const filteredConstituencies = constituencies.filter(c =>
                selectedDistrictIds.includes(c.district)
            );

            $('#constituency').empty().select2({
                placeholder: 'Select Constituencies',
                multiple: true,
                width: '100%',
                data: filteredConstituencies.map(c => ({
                    id: c._id,
                    text: capitalize(c.name)
                }))
            }).val(selectedConstituencyIds).trigger('change');

            // Filter & set wards
            const filteredWards = wards.filter(w =>
                selectedConstituencyIds.includes(w.constituency)
            );

            $('#ward').empty().select2({
                placeholder: 'Select Wards',
                multiple: true,
                width: '100%',
                data: filteredWards.map(w => ({
                    id: w._id,
                    text: capitalize(w.name)
                }))
            }).val(selectedWardIds).trigger('change');

            // Filter & set polling stations
            const filteredPollings = polling_stations.filter(p =>
                selectedWardIds.includes(p.ward)
            );

            $('#polling_station').empty().select2({
                placeholder: 'Select Polling Stations',
                multiple: true,
                width: '100%',
                data: filteredPollings.map(p => ({
                    id: p._id,
                    text: capitalize(p.name)
                }))
            }).val(selectedPollings.map(p => p._id)).trigger('change');

            $('#agent_form').parsley();
            $("#modalAgent").modal("show");
        });

        table.on('click', '.activate_agent', function (e) {
            e.preventDefault();

            const extract_td = table.row($(this).closest('tr')).data();

            const options = {
                position: "top-right",
                hideAfter: 0
            };

            let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

            let data = {
                id: extract_td.raw._id,
                active: !extract_td.raw.active,
            }

            agent("put", data).then((result) => {
                hide();
                if(!result.error) {
                    reloadTable();
                    cogoToast.success("Account successfully deactivated.", {position: "top-right"});
                }
            });

        });

        $('#agent-table tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            console.log(d);
            const mappedItems = (d?.raw?.admin_level || [])
                .filter(level =>
                    Array.isArray(level.data) &&
                    level.data.some(entry => entry?.name?.trim())
                )
                .map(level => {
                    const names = level.data
                        .filter(entry => entry?.name?.trim())   // ignore empties
                        .map(entry => entry.name.trim())
                        .join(', ');

                    return `
                        <tr>
                          <td class="text-capitalize">${level.model}:</td>
                          <td>${names}</td>
                        </tr>`;
                })
                .join('');

            return `
                    <table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">
                      <tr>
                        <td>NRC Number:</td>
                        <td>${d?.raw?.id_number ?? 'Not Set'}</td>
                      </tr>
                      <tr>
                        <td>Contact Number:</td>
                        <td>${d?.raw?.mobile_number ?? 'Not Set'}</td>
                      </tr>
                      ${mappedItems}
                      <tr>
                        <td>Created At:</td>
                        <td class="text-capitalize">
                          ${moment(d?.raw?.createdAt).format('Do MMM, YYYY HH:mm')}
                        </td>
                      </tr>
                      <tr>
                        <td>Verified By:</td>
                        <td class="text-primary">${d?.raw?.verified?.issued?.name ?? 'Not Set'}</td>
                      </tr>
                      <tr>
                        <td>Added By:</td>
                        <td class="text-primary">${d?.raw?.meta?.doc?.name ?? 'Not Set'}</td>
                      </tr>
                      <tr>
                      <tr>
                        <td>Note:</td>
                        <td>${d?.raw?.note ?? 'No Note'}</td>
                      </tr>
                      <tr>
                        <td>Device Info:</td>
                        <td>${d.raw?.device?.mobile?.brand ? capitalize(d.raw?.device?.mobile?.brand)+', '+d.raw?.device?.mobile?.model +', version: '+d.raw?.device?.mobile?.version : "Unregistered"}</td>
                      </tr>
                      <tr>
                      <tr>
                    <tr>
                    <td>Action:</td>
                    <td class="text-capitalize">
                    <nav class="nav nav-icon-only"><a href="#" class="nav-link enroll_agent"><i class="fa fa-check"></i> Mark as Adminsitator of ${d.raw?.position}</a></nav>
                    <tr>
                    </table>`;
        }

        return () => {
            table.destroy();
        }
    }, []);

    const initialize = () => {
        // Province
        $('#province').select2({
            placeholder: 'Select Provinces',
            multiple: true,
            width: '100%',
            data: province.map(p => ({ id: p._id, text: capitalize(p.name) }))
        });

        // Other dropdowns
        $('#district, #constituency, #ward, #polling_station').select2({
            placeholder: 'Select...',
            multiple: true,
            width: '100%'
        });

        // Province → District
        $('#province').on('change', function () {
            const selectedProvinces = $(this).val() || [];
            const filteredDistricts = districts.filter(d =>
                selectedProvinces.includes(d.administrative)
            );

            $('#district').empty().select2({
                placeholder: 'Select Districts',
                multiple: true,
                width: '100%',
                data: filteredDistricts.map(d => ({
                    id: d._id,
                    text: capitalize(d.name)
                }))
            }).val(null).trigger('change');

            $('#constituency, #ward, #polling_station')
                .val(null).trigger('change').empty();
        });

        // District → Constituency
        $('#district').on('change', function () {
            const selectedDistricts = $(this).val() || [];
            const filteredConstituencies = constituencies.filter(c =>
                selectedDistricts.includes(c.district)
            );

            $('#constituency').empty().select2({
                placeholder: 'Select Constituencies',
                multiple: true,
                width: '100%',
                data: filteredConstituencies.map(c => ({
                    id: c._id,
                    text: capitalize(c.name)
                }))
            }).val(null).trigger('change');

            $('#ward, #polling_station')
                .val(null).trigger('change').empty();
        });

        // Constituency → Ward
        $('#constituency').on('change', function () {
            const selectedConstituencies = $(this).val() || [];
            const filteredWards = wards.filter(w =>
                selectedConstituencies.includes(w.constituency)
            );

            $('#ward').empty().select2({
                placeholder: 'Select Wards',
                multiple: true,
                width: '100%',
                data: filteredWards.map(w => ({
                    id: w._id,
                    text: capitalize(w.name)
                }))
            }).val(null).trigger('change');

            $('#polling_station').val(null).trigger('change').empty();
        });

        // Ward → Polling Station
        $('#ward').on('change', function () {
            const selectedWards = $(this).val() || [];
            const filteredPollings = polling_stations.filter(p =>
                selectedWards.includes(p.ward)
            );

            $('#polling_station').empty().select2({
                placeholder: 'Select Polling Stations',
                multiple: true,
                width: '100%',
                data: filteredPollings.map(p => ({
                    id: p._id,
                    text: capitalize(p.name)
                }))
            }).val(null).trigger('change');
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let name = $('#name').val();
        let username = $('#username').val();
        let mobile_number = $('#contact-number').val();
        let id_number = $('#id-number').val();
        let password = $('#password').val();
        let position = $('#position').val();
        let provincial = $('#province').val();
        let constituency = $('#constituency').val();
        let ward = $('#ward').val();
        let polling = $('#polling_station').val();

        let data = {
            name,
            username,
            id_number,
            mobile_number,
            position,
            password,
            access: {
                statistic: $('#b1a').is(':checked'),
                agent: $('#b2a').is(':checked')
            },
            admin_level: []
        };

        if(provincial.length > 0) {
            data.admin_level.push({
                model: "administrative",
                data: provincial
            });
        }

        if(constituency.length > 0) {
            data.admin_level.push({
                model: "constituency",
                data: constituency
            });
        }

        if(ward.length > 0) {
            data.admin_level.push({
                model: "ward",
                data: ward
            });
        }

        if(polling.length > 0) {
            data.admin_level.push({
                model: "polling",
                data: polling
            });
        }

        if(editForm) {
            Object.assign(data, {id: editId});
            agent("put", data).then((result) => {
                setStateReady(false);
                if(!result.error) {
                    cogoToast.success("Agent successfully updated.", {position: "top-right", hideAfter: 5});
                    resetForm("modalAgent", "agent_form");
                    reloadTable();
                }
            });

            return false;
        }

        setStateReady(true);

        agent("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Account successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalAgent", "agent_form");
                reloadTable();
            }
        });
    };

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        $('#province, #constituency, #ward, #polling_station')
            .val(null)
            .trigger('change')
            .empty();
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const handleShowModal = () => {
        setEditForm(false);
        $('#agent_form').parsley();

        let name = $("#name");
        let username = $("#username");

        name.prop('disabled', false);
        username.prop('disabled', false);

        $("#password").prop('required', true);
        initialize();
        $("#modalAgent").modal("show");
    };

    const handleLeaderboard = () => {
        setId(new Date().getTime());
        $("#modalLeaderboard").modal("show");
    }

    const reloadTable = () => {
        $('#agent-table').DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Agent</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Agent</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <button className="btn btn-sm pd-x-15 btn-secondary btn-uppercase mg-l-5 outline-none" onClick={handleLeaderboard.bind()}><i className="wd-10 mg-r-5 fa fa-signal"></i> Leaderboard</button>
                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-user-plus"></i> Add New</button>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Agent List</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable.bind()} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="agent-table" className="table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-20p">Name</th>
                                        <th className="wd-20p">Username</th>
                                        <th className="wd-20p">Position</th>
                                        <th className="wd-20p">Active</th>
                                        <th className="wd-20p">Actions</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="modal fade" id="modalAgent" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalAgent", "agent_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">{editForm ? "Edit Agent" : "Create Agent"}</h4><p className="tx-13 tx-color-02 mg-b-0">{editForm ? "Edit" : "Create"} agent to have access to the console</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="agent_form" className="parsley-style-1" onSubmit={handleSubmit.bind()}>
                                        <div id="nameWrapper" className="form-group parsley-input">
                                            <label>Full Name<span className="tx-danger">*</span></label>
                                            <input id="name" type="text" className="form-control"
                                                   placeholder="Enter full name"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#nameWrapper" required/>
                                        </div>

                                        <div id="usernameWrapper" className="form-group parsley-input">
                                            <div className="d-flex justify-content-between">
                                                <label>Username<span className="tx-danger">*</span></label>
                                                <a href="javascript:void(0)" onClick={() => $("#username").val(generateChar(7))} className="link-01">Generate</a>
                                            </div>
                                            <input id="username" type="text" className="form-control"
                                                   placeholder="Enter username"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#usernameWrapper" required/>
                                        </div>

                                        <div id="contactWrapper" className="form-group parsley-input">
                                            <label>Contact Number<span className="tx-danger">*</span></label>
                                            <input id="contact-number" type="text" className="form-control"
                                                   placeholder="Enter contact number"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#contactWrapper" required/>
                                        </div>

                                        <div id="nrcWrapper" className="form-group parsley-input">
                                            <label>NRC Number<span className="tx-danger">*</span></label>
                                            <input id="id-number" type="text" className="form-control"
                                                   placeholder="Enter NRC Number"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#nrcWrapper"
                                                   required
                                            />
                                        </div>

                                        <div id="roleWrapper" className="form-group parsley-input">
                                            <label>Position<span className="tx-danger">*</span></label>
                                            <select className="custom-select" id="position" required>
                                                <option value="" disabled selected>Select Position</option>
                                                <option value="provincial coordinator">Provincial Coordinator</option>
                                                <option value="constituency coordinator">Constituency Coordinator</option>
                                                <option value="ward coordinator">Ward Coordinator</option>
                                                <option value="polling station coordinator">Polling Station Coordinator</option>
                                            </select>
                                        </div>

                                        <div id="provinceWrapper" className="form-group parsley-input">
                                            <label>Province</label>
                                            <select id="province"
                                                    data-width="100%"
                                                    multiple="multiple"
                                                    data-parsley-class-handler="#provinceWrapper"
                                                    data-parsley-errors-container="#provinceWrapper"
                                                    className="custom-select"
                                            >
                                            </select>
                                        </div>

                                        <div id="districtWrapper" className="form-group parsley-input">
                                            <label>District</label>
                                            <select id="district"
                                                    data-width="100%"
                                                    multiple="multiple"
                                                    data-parsley-class-handler="#districtWrapper"
                                                    data-parsley-errors-container="#districtWrapper"
                                                    className="custom-select"
                                            ></select>
                                        </div>

                                        <div id="constituencyWrapper" className="form-group parsley-input">
                                            <label>Constituency</label>
                                            <select id="constituency"
                                                    data-width="100%"
                                                    multiple="multiple"
                                                    data-parsley-class-handler="#constituencyWrapper"
                                                    data-parsley-errors-container="#constituencyWrapper"
                                                    className="custom-select"
                                            ></select>
                                        </div>

                                        <div id="wardWrapper" className="form-group parsley-input">
                                            <label>Ward</label>
                                            <select id="ward"
                                                    data-width="100%"
                                                    multiple="multiple"
                                                    data-parsley-class-handler="#wardWrapper"
                                                    data-parsley-errors-container="#wardWrapper"
                                                    className="custom-select"
                                            ></select>
                                        </div>

                                        <div id="pollingStationWrapper" className="form-group parsley-input">
                                            <label>Polling Station</label>
                                            <select id="polling_station"
                                                    data-width="100%"
                                                    multiple="multiple"
                                                    data-parsley-class-handler="#pollingStationWrapper"
                                                    data-parsley-errors-container="#pollingStationWrapper"
                                                    className="custom-select"
                                            ></select>
                                        </div>

                                        <div id="passwordWrapper" className="form-group parsley-input">
                                            <div className="d-flex justify-content-between">
                                                <label>Password<span className="tx-danger">*</span></label>
                                                <a href="javascript:void(0)" onClick={() => $("#password").val(generateChar(7))} className="link-01">Generate</a>
                                            </div>
                                            <input id="password" type="text" className="form-control"
                                                   placeholder="Enter new password"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#passwordWrapper"/>
                                        </div>

                                        <div className="form-group">
                                            <div data-label="Access Privilege" className="df-example mg-b-5">
                                                <div id="cbWrapper2" className="parsley-checkbox pos-relative">
                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox" name="_form[]"
                                                               data-parsley-class-handler="#cbWrapper2"
                                                               data-parsley-errors-container="#cbErrorContainer2"
                                                               data-parsley-multiple="_form" id="b1a"/>
                                                        <label className="custom-control-label" htmlFor="b1a">View Statistic</label>
                                                    </div>

                                                    <div className="custom-control custom-checkbox">
                                                        <input className="custom-control-input" type="checkbox"
                                                               name="_form[]"
                                                               data-parsley-multiple="_form"
                                                               id="b2a"/>
                                                        <label className="custom-control-label" htmlFor="b2a">Manage Agent</label>
                                                    </div>

                                                    <div id="cbErrorContainer2" className="wd-100p pos-absolute b-0 l-0"/>
                                                </div>
                                            </div>
                                        </div>

                                        {stateReady ? <button disabled className="btn btn-primary btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : editForm ? <button className="btn btn-primary btn-block">Update Account</button> : <button className="btn btn-primary btn-block">Create Account</button>}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p className="mg-b-0 data-message">Empty</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                    <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalLeaderboard" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel6">Leaderboard</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => $("#tx-support-level").text("Select Date")}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <DTLeaderBoard id={id}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Agent;
